// Close the dropdown menu if the user clicks outside of it
window.onclick = function(event) {
  var dropdown = document.getElementById("myDropdown");
  var caret = document.getElementById("flagCaret");
  var dropToggle = event.target.matches('.drop-toggle');

  function flipCaret() {
    caret.classList.toggle('down-caret');
    caret.classList.toggle('up-caret');
  }

  if (dropToggle) {
    dropdown.classList.toggle('show');
    flipCaret();
  }

  if (!dropToggle && dropdown.classList.contains('show')) {
    dropdown.classList.remove('show');
    flipCaret();
  }
}
